import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import TnoMediaLabLogo, { MEDIA_LAB_TAGLINES } from 'components/TnoMediaLabLogo';

const Who = ({ themeMode = 'light', content = {}, forceContent = false, hideLogo = false }) => {
  void themeMode;
  const theme = useTheme();

  const isMediaLabRoute =
    !forceContent &&
    typeof window !== 'undefined' &&
    (window.location.hostname === 'medialab.tnonetwork.com' ||
      window.location.pathname === '/medialab' ||
      window.location.pathname.startsWith('/medialab/'));

  const finalContent = isMediaLabRoute ? {} : content;

  return (
    <Box>
      <Box marginBottom={4}>
        {!hideLogo && (
          <Box display="flex" justifyContent="center" marginBottom={3}>
            <TnoMediaLabLogo
              tagline={MEDIA_LAB_TAGLINES.producers}
              alt="TNO Media Lab"
              height={{ xs: 44, md: 56 }}
              width="auto"
              sx={{ mb: 0 }}
            />
          </Box>
        )}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ gap: { xs: 1.25, md: 2 }, mb: 1 }}
        >
          <Box
            component="img"
            src="/images/logos/iso_black.webp"
            alt=""
            sx={{
              height: { xs: 40, sm: 52, md: 64 },
              width: 'auto',
              flexShrink: 0,
              display: 'block',
            }}
          />
          <Box
            component={Typography}
            fontWeight={700}
            variant={'h3'}
            color={theme.palette.primary.main}
            sx={{
              m: 0,
              textAlign: 'left',
              lineHeight: 1.2,
              fontSize: { xs: '1.45rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            {finalContent.title ||
              'TNO Media Lab: la productora de shows de TNO Network'}
          </Box>
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          {finalContent.subtitle ||
            'Tú llegas con el programa. El Lab pone el estudio, el equipo y la salida al aire: estrenamos en el streaming en vivo de TNO y dejamos tu show en on-demand, clips y tnonetwork.com.'}
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 2 }}
        >
          {finalContent.description ||
            'No armas un canal ni contratas productora por fuera. Nos encargamos de cámaras, sonido, streaming y publicación. Tú conduces; nosotros producimos. El estreno sale en la señal en vivo y el mismo master queda en on-demand, clips y TNO.'}
        </Typography>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
  content: PropTypes.object,
  forceContent: PropTypes.bool,
  hideLogo: PropTypes.bool,
};

export default Who;
